import { Button, Form, Modal, Input, Select } from 'antd';
import { useEffect, useState } from 'react';
import { createAccount } from '../../../api';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../components/message';
import { UserType } from '../../../model/api-modules';
import { md5 } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly getUserList: () => Promise<void>;
}

export const CreateAccount = (props: IProps) => {
  const [showCreateAccountModal, setShowCreateAccountModal] =
    useState<boolean>(false);
  const [emailValue, setEmailValue] = useState<string>('');
  const [passwordValue, setPasswordValue] = useState<string>('');
  const [userTypeValue, setUserTypeValue] = useState<number>(4);

  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [createAccountForm] = Form.useForm();
  const handleCreateAccountCancel = () => setShowCreateAccountModal(false);

  const userTypeList = [
    {
      label: getFormatMessage('ioa'),
      value: 3,
    },
    {
      label: getFormatMessage('email_uppercase'),
      value: 4,
    },
  ];

  useEffect(() => {
    setEmailValue('');
    setPasswordValue('');
    createAccountForm.setFieldValue('email', '');
    createAccountForm.setFieldValue('password', '');
  }, [showCreateAccountModal]);

  const handleAssistAddEnvSubmit = async () => {
    try {
      const email = createAccountForm.getFieldValue('email');
      const password = createAccountForm.getFieldValue('password');
      const userType = createAccountForm.getFieldValue('type');
      const regRegisterLength = /^.{14,}$/;
      // 正则表达式用于验证密码是否包含至少一个小写字母、一个大写字母、一个数字和一个特殊字符
      const reg = new RegExp(
        '^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{14,}$'
      );
      if (!email) {
        messageWarning(getFormatMessage('please_enter_email'));
        return;
      }
      if (!/^[\S]{1,30}@[\S]{1,30}$/.test(email)) {
        messageWarning(getFormatMessage('email_validation_format'));
        return;
      }
      if (!password && userType !== UserType.IOA) {
        messageWarning(getFormatMessage('please_enter_password'));
        return;
      }
      if (
        !regRegisterLength.test(password.trim()) &&
        userType !== UserType.IOA
      ) {
        messageWarning(getFormatMessage('password_short'));
        return;
      }
      if (!reg.test(password.trim()) && userType !== UserType.IOA) {
        messageWarning(getFormatMessage('password_not_complexity'));
        return;
      }
      setConfirmLoading(true);
      const res = await createAccount({
        email,
        password: md5(password.trim()),
        validateRef: '',
        userType: userTypeValue,
        ticket: '',
        randstr: '',
      });
      if (res.code === 0) {
        messageSuccess(getFormatMessage('account_create_success'));
        // setUserTypeValue(4);
        setEmailValue('');
        setPasswordValue('');
        // createAccountForm.setFieldValue('type', 4);
        createAccountForm.setFieldValue('email', '');
        createAccountForm.setFieldValue('password', '');
        props.getUserList();
        // setShowCreateAccountModal(false);
      } else {
        if (res.msg) {
          messageError(res.msg);
        } else {
          messageError(getFormatMessage('account_create_fail'));
        }
      }
      setConfirmLoading(false);
    } catch (err: any) {
      setConfirmLoading(false);
      console.error(err);

      messageError(getFormatMessage('account_create_fail'));
    }
  };
  const openCreateAccountModal = () => {
    setShowCreateAccountModal(true);
  };

  const handleEmailValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailValue(e.target.value);
  };
  const handlePasswordValueChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPasswordValue(e.target.value);
  };
  const onUserTypeChange = (userType: number) => {
    setUserTypeValue(userType);
  };

  return (
    <div>
      <Button
        className="gc-btn gc-btn-primary assist-open-button admin-btn"
        onClick={openCreateAccountModal}
      >
        <span>{getFormatMessage('create_account')}</span>
      </Button>
      <Modal
        title={getFormatMessage('create_account')}
        open={showCreateAccountModal}
        onOk={handleAssistAddEnvSubmit}
        onCancel={handleCreateAccountCancel}
        okText={getFormatMessage('create')}
        confirmLoading={confirmLoading}
        className="create-account-modal"
        maskClosable={false}
      >
        <Form form={createAccountForm} colon={false}>
          <Form.Item name="type" label={getFormatMessage('user_type')}>
            <Select onChange={onUserTypeChange} defaultValue={4}>
              {userTypeList.map((item) => (
                <Select.Option
                  value={item.value}
                  label={item.label}
                  key={item.value}
                >
                  <div className="create-account-type-select-option">
                    <div>{item.label}</div>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="email" label={getFormatMessage('email_uppercase')}>
            <Input
              placeholder={getFormatMessage('please_enter_email')}
              value={emailValue}
              onChange={handleEmailValueChange}
              style={{ marginRight: 8 }}
              allowClear
            />
          </Form.Item>
          {userTypeValue !== UserType.IOA && (
            <Form.Item name="password" label={getFormatMessage('password')}>
              <Input
                placeholder={getFormatMessage('please_enter_password')}
                value={passwordValue}
                onChange={handlePasswordValueChange}
                style={{ marginRight: 8 }}
                allowClear
              />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </div>
  );
};
